export default __webpack_public_path__ + "media/images/landing-19-550x420-8d911ade583f3e02a9912733e56ed6a7.jpg";